import cloneDeep from 'lodash/cloneDeep'
import baseDefaults from '../Base/Base.defaults'

export default  {
  ...cloneDeep(baseDefaults),
  itemTitleColor: 'var(--color-primary)',
  itemTextColor: 'var(--color-text)',
  itemDotColor: 'var(--color-primary)',
  itemIconColor: 'var(--color-white)',
  itemIconSize: {
    desktop: 14
  },
  dotSize: {
    desktop: 28,
  },
  items: [
    {
      title: 'Your number #1 benefit, right here',
      description: '',
      icon: 'check',
      id: 'random'
    }
  ],
  columns: {
    desktop: 1
  },
  columnGap: {
    desktop: 0
  }
}

